import { Button, Paper } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React, { FC, useCallback } from "react";
import Dropzone from "react-dropzone";

import useStyles from "./styles";

interface TUploadComponentProps {
  onSelectFile: (file: File) => void;
}

const UploadComponent: FC<TUploadComponentProps> = ({ onSelectFile }) => {
  const classes = useStyles({});
  const uploadInputRef = React.useRef(null);

  const handleOnDrop = useCallback((files: File[]) => {
    onSelectFile(files[0]);
  }, []);

  const handleSelectFileClick = useCallback(() => {
    uploadInputRef.current.click();
  }, []);

  return (
    <Dropzone onDrop={handleOnDrop} disableClick={true}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()}>
          <Paper className={classes.styedPaper}>
            <input
              {...getInputProps()}
              id="fileUploadInputId"
              multiple={false}
              ref={uploadInputRef}
              type="file"
            />
            <CloudUploadIcon
              className={classes.styledCloudUploadIcon}
              htmlColor="#747C8C"
            />
            <div className={classes.styledDragOrDropFilesText}>
              Drag or Drop Files
            </div>
            <div className={classes.styledOrText}>Or</div>
            <Button
              variant="contained"
              onClick={handleSelectFileClick}
              className={classes.selectFileButton}
            >
              SELECT A FILE
            </Button>
            <div>Accepts only XLSX files</div>
            <div>Max file size is 2.5MB</div>
          </Paper>
        </div>
      )}
    </Dropzone>
  );
};

export default UploadComponent;
